export const GET_BUSINESS_PROFILE = 'GET_BUSINESS_PROFILE'
export const GET_BUSINESS_PROFILE_SUCCESS = 'GET_BUSINESS_PROFILE_SUCCESS'
export const GET_BUSINESS_PROFILE_FAILURE = 'GET_BUSINESS_PROFILE_FAILURE'

export const PATCH_BUSINESS_PROFILE = 'PATCH_BUSINESS_PROFILE'
export const PATCH_BUSINESS_PROFILE_SUCCESS = 'PATCH_BUSINESS_PROFILE_SUCCESS'
export const PATCH_BUSINESS_PROFILE_FAILURE = 'PATCH_BUSINESS_PROFILE_FAILURE'